// Water Planner date/time display helpers. Renders TT.MM.JJJJ everywhere and
// TT.MM.JJJJ, HH:MM Uhr for timestamps. Never used for sorting — sorting
// continues to compare the raw ISO strings the API returns.

function pad2(n) {
  return String(n).padStart(2, "0");
}

/** ISO-Datum ("2026-09-12") oder Date → "12.09.2026". Fällt bei ungültigem
 *  Input auf den Originalwert zurück, damit UI nichts leert. */
export function formatDate(input) {
  if (!input) return "";
  if (input instanceof Date && !isNaN(input.getTime())) {
    return `${pad2(input.getDate())}.${pad2(input.getMonth() + 1)}.${input.getFullYear()}`;
  }
  const s = String(input);
  // Pure YYYY-MM-DD → parse without timezone shift.
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
}

/** ISO-Zeitstempel → "12.09.2026, 14:45 Uhr". */
export function formatDateTime(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}, ${pad2(d.getHours())}:${pad2(d.getMinutes())} Uhr`;
}

/** Kurzform für Wochenlabels: "12.09.". */
export function formatDateShort(input) {
  const full = formatDate(input);
  const m = full.match(/^(\d{2}\.\d{2})/);
  return m ? `${m[1]}.` : full;
}
